"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _formWrapper = _interopRequireDefault(require("../../formWrapper.js"));
var _reportTemplates = _interopRequireDefault(require("../reportTemplates.js"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var fields = ['reportTemplateSettings'];
var Report = function Report(props) {
  var reportTemplateSettings = props.fields.reportTemplateSettings;
  var reportTemplateHandle = props.settings.reportTemplateHandle;
  var currentReportTemplate = _reportTemplates["default"].find(function (item) {
    return item.handle === reportTemplateHandle;
  });
  if (!currentReportTemplate) {
    return "Could not find Report Template with handle '".concat(reportTemplateHandle, "'.");
  }
  var Player = currentReportTemplate.player;
  var Builder = currentReportTemplate.builder;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].player
  }, /*#__PURE__*/_react["default"].createElement(Player, {
    isPreview: true,
    settings: props.settings.reportTemplateSettings,
    filterProps: currentReportTemplate.filterProps ? currentReportTemplate.filterProps : {},
    widgetProps: currentReportTemplate.widgetProps ? currentReportTemplate.widgetProps : {}
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].builder
  }, /*#__PURE__*/_react["default"].createElement(Builder, {
    onValidChange: (0, _debounce2["default"])(function (value) {
      return reportTemplateSettings.onChange(value);
    }, 300),
    initialValues: props.settings.reportTemplateSettings,
    widgetProps: currentReportTemplate.widgetProps ? currentReportTemplate.widgetProps : {}
  }))));
};
var _default = exports["default"] = (0, _formWrapper["default"])({
  fields: fields
})(Report);